<template>
  <div>
    <v-card elevation="0">
      <core-tech></core-tech>
    </v-card>
  </div>
</template>

<script>
import busArchi from './busArchi.vue'
import coreTech from './coreTech.vue'

export default {
  name: 'prod-core-card',
  components: { busArchi, coreTech },
  data () {
    return {}
  }
}
</script>

<style scoped>
.core-title {
  font-size: 30px;
  font-weight: 500;
  height: 190px;
  color: #fff;
}

.core-img {
  position: absolute;
  height: 190px;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/pc/home/prodCore/prodCoreCard.vue